module.exports = __webpack_public_path__ + "media/images/iconTrash-907ac07bf780b507e1a8506c3bcf2ad4.png";